import imageOne from '../images/real-eastate-dominican-republic-1.jpeg'
import imageTwo from '../images/real-eastate-lagos-1.jpeg'
import imageThree from '../images/real-eastate-thailand.jpeg'
import imageFour from '../images/real-eastate-indonesia.avif'

export const SliderData = [
  {
    title: "Villa La Romana, Dominican Republic",
    price: '$2,860,000',
    path: '/luxuary',
    label: 'View Home',
    image: imageOne,
    alt: 'Villa La Romana, Dominican Republic'
  },

  {
    title: 'Villas in Lagos, West Africa',
    price: '$8,420,000',
    path: '/homes',
    label: 'View Home',
    image: imageTwo,
    alt: 'Luxury Villas in Lagos'
  },

  {
    title: 'Thailand haute Villa',
    price: '$4,280,000',
    path: '/life',
    label: 'View Home',
    image: imageThree,
    alt: 'Thailand haute Villa'
  },

  {
    title: 'Luxury Villa in Bali, Indoneisa',
    price: '$6,860,000',
    path: '/homes',
    label: 'View Home',
    image: imageFour,
    alt: 'Luxury Villa in Bali'
  }
]